export default "__VITE_ASSET__CPEas7cn__"